module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("avbwV"))).then(() => parcelRequire('1iHdE'));